import { trans } from 'Rentlio/helper/translation'

export function termsOfServiceAcceptedConstraint(value) {
  return !value ? trans('TOSValidationError') : null
}
